import { ErrorData } from 'types/embedded/error';
import { getMessageFromErrorBody } from 'utils/getMessageFromErrorBody';

const FALLBACK_MESSAGE = 'Файлы не соответствуют требованиям';

export const getReconciliationErrorMessage = (error: unknown): string => {
  const data = (error as { data?: ErrorData } | undefined)?.data;

  return getMessageFromErrorBody(data ?? null) || FALLBACK_MESSAGE;
};
